import { Navigate } from 'react-router';
import { useAuth } from '../../hooks/useAuth';
import { PermissionGuard } from './PermissionGuard';

// Landing "/" — não é mais uma tela, só decide pra onde cada um vai:
//   gestão (manager/coordinator) → /inicio, que absorveu a antiga Visão Geral
//   operador → Minha mesa (o que é dele em todos os boards + conversas comigo)
//   resto → Painel de Atendimento se tiver 'secretaria'; senão /workspace
//     (sempre acessível, nunca /sem-acesso, que fica fora do AppLayout e
//     travaria o usuário sem sidebar/logout).
export default function RootRedirect() {
  const { user } = useAuth();
  if (!user) return null;

  const role = user.profile?.role;
  if (!user.is_staff && (role === 'manager' || role === 'coordinator')) {
    return <Navigate to="/inicio" replace />;
  }
  if (!user.is_staff && role === 'operator') {
    return <Navigate to="/minha-mesa" replace />;
  }
  return (
    <PermissionGuard module="secretaria" bypassRoles={['operator']} redirectTo="/workspace?motivo=sem_modulo">
      <Navigate to="/atendimento/conversas" replace />
    </PermissionGuard>
  );
}
